import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/3d693276a5424479ffa5f1cc868e7c58/183d8ecbf6c955dca59ecb48a236f3b9.jpeg"
          alt="IKIRU Epilepsy Foundation community"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#2D0A35]/85 via-[#4B1060]/65 to-[#2D0A35]/40"></div>
      </div>

      {/* Purple ribbon accent top */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#4B0082] via-[#C084FC] to-[#7B2D8B] z-20"></div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-10 pt-32 pb-20">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-purple-400/40 bg-purple-900/30 backdrop-blur-sm mb-8">
            <span className="w-2 h-2 rounded-full bg-[#C084FC] animate-pulse"></span>
            <span className="text-purple-200 text-sm tracking-wide">Transforming Lives Across Africa</span>
          </div>

          <h1 className="text-5xl md:text-7xl font-extrabold text-white leading-tight mb-6">
            Giving <span className="text-[#C084FC]">Life,</span><br />
            Hope, and<br />
            <span className="text-[#C084FC]">Dignity</span>
          </h1>

          <p className="text-white/80 text-lg md:text-xl leading-relaxed mb-10 max-w-xl">
            IKIRU – The Epilepsy Foundation is dedicated to transforming lives and fostering a society where individuals living with epilepsy are empowered, supported, and free from stigma across Nigeria and Africa.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/get-involved"
              className="px-8 py-4 rounded-full bg-[#7B2D8B] text-white font-semibold text-base hover:bg-[#6a2578] transition-all cursor-pointer whitespace-nowrap text-center"
            >
              Donate Now
            </Link>
            <Link
              to="/programs"
              className="px-8 py-4 rounded-full border-2 border-purple-300/60 text-white font-semibold text-base hover:bg-white/10 transition-all cursor-pointer whitespace-nowrap text-center flex items-center justify-center gap-2"
            >
              Our Programs <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>

        {/* Stats bar */}
        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-6">
          {[
            { value: '50M+', label: 'People Affected Globally' },
            { value: '1M+', label: 'Awareness Target by 2027' },
            { value: '500', label: 'Patients Supported' },
            { value: '10', label: 'Community Support Groups' },
          ].map((stat) => (
            <div key={stat.label} className="bg-purple-900/30 backdrop-blur-sm rounded-2xl p-5 border border-purple-400/20">
              <div className="text-3xl font-extrabold text-[#C084FC] mb-1">{stat.value}</div>
              <div className="text-white/70 text-sm leading-snug">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/50 text-xs tracking-widest uppercase">Scroll</span>
        <i className="ri-arrow-down-line text-white/50"></i>
      </div>
    </section>
  );
}
